import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import POYarnFabric from './pages/POYarnFabric';
import Login from './pages/Login';
import POAccessories from './pages/POAccessories';
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
  Tooltip,
} from '@mui/material';
import LinkIcon from '@mui/icons-material/Link';
import config from './config';

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/login" />;
};

const Layout = ({ children }) => {
  const [openDialog, setOpenDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState(null);

  const handleWebhookSend = async () => {
    setLoading(true);
    setResponse(null);
    try {
      const res = await fetch(config.WEBHOOK_ENDPOINT, {
        method: 'POST',
      });

      const rawText = await res.text();
      const fullResponse = `Status: ${res.status} ${res.statusText}\n\n${rawText}`;
      setResponse(fullResponse);
    } catch (err) {
      setResponse(`❌ Error: ${err.message}`);
    }
    setLoading(false);
  };

  const resetDialog = () => {
    setOpenDialog(false);
    setLoading(false);
    setResponse(null);
  };

  return (
    <Box>
      <AppBar
        position="static"
        sx={{
          mb: 2,
          backgroundColor: '#1a237e',
          boxShadow: 'none',
        }}
      >
        <Toolbar sx={{ justifyContent: 'space-between' }}>
          <Typography
            variant="h6"
            component="div"
            sx={{
              fontFamily: 'Segoe UI, Roboto, Helvetica, Arial, sans-serif',
              fontWeight: 600,
              letterSpacing: '0.5px',
              flexGrow: 1,
              textAlign: 'center',
            }}
          >
            SWIFT APPROVE
          </Typography>
          <Tooltip title="Send Webhook">
            <IconButton color="inherit" onClick={() => setOpenDialog(true)}>
              <LinkIcon />
            </IconButton>
          </Tooltip>
        </Toolbar>
      </AppBar>

      <Dialog open={openDialog} onClose={resetDialog} maxWidth="sm" fullWidth>
        <DialogTitle>Send Webhook</DialogTitle>
        <DialogContent dividers>
          {loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
              <CircularProgress />
            </Box>
          ) : (
            <Box
              sx={{
                whiteSpace: 'pre-wrap',
                fontSize: 14,
                fontFamily: 'monospace',
              }}
            >
              {response ?? 'Do you want to send the webhook to restart the backend?'}
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          {!response && !loading && (
            <Button onClick={handleWebhookSend} color="primary" variant="contained">
              Send
            </Button>
          )}
          <Button onClick={resetDialog} color="secondary">
            {response ? 'Close' : 'Cancel'}
          </Button>
        </DialogActions>
      </Dialog>

      <Box sx={{ px: 2 }}>{children}</Box>
    </Box>
  );
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Layout><Login /></Layout>} />
        <Route
          path="/"
          element={
            <PrivateRoute>
              <Layout><Home /></Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/po/yarn-fabric"
          element={
            <PrivateRoute>
              <Layout><POYarnFabric /></Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/po/accessories"
          element={
            <PrivateRoute>
              <Layout><POAccessories /></Layout>
            </PrivateRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
